import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  margin-top: -24px;
`;

export const Container = styled.div`
  margin-left: 4px;
  width: 32%;
`;

export const ActiveLine = styled.div`
  background-color: ${ColorV2.SimflexityGreen};
  border-radius: 3px;
  height: 5px;
`;

export const InactiveLine = styled.div`
  background-color: ${ColorV2.Blue6};
  border-radius: 3px;
  height: 5px;
`;
